export const menuScrollHandler = (isHover: boolean, lastScroll: number, setLastScroll: (x:any) => void, menuOpen?: boolean) => {
    let currentScroll = document.documentElement.scrollTop
    const header = document.querySelector('.header')
    if (!isHover) {
        if (currentScroll > lastScroll) {
            if (!header?.classList.contains('header--hidden')) header?.classList.add('header--hidden')
        } else {
            if (header?.classList.contains('header--hidden')) header?.classList.remove('header--hidden')
        }
        setLastScroll(currentScroll)
    }

    if (currentScroll <= 80) {
        if (header?.classList.contains('header--hidden')) header?.classList.remove('header--hidden')
        if (header?.classList.contains('header--fixed')) header?.classList.remove('header--fixed')
    } else {
        if (!header?.classList.contains('header--fixed')) header?.classList.add('header--fixed')
    }
}